import axios from 'axios';
import omit from 'lodash/omit';
import config from '../../config'

export const setHeaders = (headers) => {
	const newKeys = {...config.defaultHeaders, ...omit({...axios.defaults.headers.common}, Object.keys(headers))};

	for(const headerKey of Object.keys(headers)) {
		if(headers[headerKey] !== false) {
			newKeys[headerKey] = headers[headerKey];
		}
	}
	
	axios.defaults.headers.common = newKeys;
}